import React from 'react';
import "../CSS_stuff/FormatUpcomingBook.css";
// If you want to show an image later, import it and set imageSrc below:
// import myImage from '../assets/2025-Upcoming-Books.jpg';

function UpcomingBooks() {

  // Optional image: set to an imported image (myImage) when you want to display it.
  // Leave as null to hide the image.
  const imageSrc = null; // e.g. set to myImage to enable

  // Caption to show at the top of the upcoming books section
  const caption = "Available now ONLY on Kickstarter (include link). Available everywhere in March 2026";

  // Add your upcoming books list here (title + abbreviation)
  const upcoming = [
    { title: "An All-Too-Easy Answer", abbr: "KotRMain-4-WoS-1" }
  ];

  return (
    <div className="upcoming-page">
      {/* Image will render only if imageSrc is set */}
      {imageSrc && (
        <div className="image-container">
          <img src={imageSrc} alt="Upcoming books banner" />
        </div>
      )}

      <section className="upcoming-list" aria-labelledby="upcoming-heading">
        {/* Caption shown above the heading */}
        <p className="upcoming-caption">{caption}</p>

        <h2 id="upcoming-heading">Upcoming Books</h2>
        <ul>
          {upcoming.map((book, idx) => (
            <li key={idx}>
              <strong>{book.abbr}</strong> — {book.title}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default UpcomingBooks;